import {TweakpaneImagePlugin} from './plugin';

export const plugin = TweakpaneImagePlugin;
